/**
 * Informations sur les types d'actions GreenMiles
 */

// Informations détaillées pour chaque type d'action selon la documentation mise à jour
export const ACTION_TYPES = {
  LUNICLEAN: "LUNICLEAN",
  LUNISHOWER: "LUNISHOWER",
  YESNO: "YESNO",
  YESNOSTAY: "YESNOSTAY",
  CUSTOM: "CUSTOM",
  REVIEW: "REVIEW",
  LIMEAT: "LIMEAT",
  CLAIM: "CLAIM",
  PROOF: "PROOF",
  YESNOMAIL: "YESNOMAIL",
  QUIZ: "QUIZ",
  LINK: "LINK",
  SKIP_SERVICE: "SKIP_SERVICE",
};

export const getActionTypeInfo = (type) => {
  const typeInfoMap = {
    [ACTION_TYPES.LUNICLEAN]: {
      name: "LUNICLEAN",
      displayName: "LuniClean",
      description: "Actions de nettoyage des serviettes/draps",
      periodicity: "Par nuit, mais peut être fait aujourd'hui ou demain",
      restriction: "Proposé uniquement si le séjour dure plus de 2 jours",
      requiresPositiveResponse: false,
      requiresQuestion: false,
      requiresCustomOptions: false,
      example: {
        name: "Serviettes et draps",
        description: "Aidez-nous à préserver l'environnement",
      },
    },
    [ACTION_TYPES.LUNISHOWER]: {
      name: "LUNISHOWER",
      displayName: "LuniShower",
      description: "Actions liées aux douches intelligentes",
      periodicity: "Quotidienne (par nuit)",
      restriction: 'Masquée pour les chambres témoin (rTag = "Témoin"). Visible pour les autres selon les règles option eau.',
      requiresPositiveResponse: false,
      requiresQuestion: false,
      requiresCustomOptions: false,
      example: {
        name: "Défi Douche Écologique",
        description: "Respectez l'objectif de consommation d'eau",
      },
    },
    [ACTION_TYPES.YESNO]: {
      name: "YESNO",
      displayName: "Yes/No",
      description: "Questions Oui/Non quotidiennes",
      periodicity: "Quotidienne (par nuit)",
      restriction: "Aucune",
      requiresPositiveResponse: true,
      requiresQuestion: true,
      requiresCustomOptions: false,
      example: {
        name: "Question Écologique du Jour",
        description: "Adoptez des gestes éco-responsables",
        question: "Avez-vous éteint les lumières en sortant de votre chambre ?",
      },
    },
    [ACTION_TYPES.YESNOSTAY]: {
      name: "YESNOSTAY",
      displayName: "Yes/No Stay",
      description: "Questions Oui/Non pour tout le séjour",
      periodicity: "Une seule fois par séjour",
      restriction: "Aucune",
      requiresPositiveResponse: true,
      requiresQuestion: true,
      requiresCustomOptions: false,
      example: {
        name: "Engagement Éco du Séjour",
        description: "Prenez un engagement écologique pour votre séjour",
        question: "Vous engagez-vous à adopter des gestes éco-responsables durant votre séjour ?",
      },
    },
    [ACTION_TYPES.CUSTOM]: {
      name: "CUSTOM",
      displayName: "Custom",
      description: "Actions avec options de choix multiples",
      periodicity: "Variable",
      restriction: "Nécessite la création d'options de choix",
      requiresPositiveResponse: false,
      requiresQuestion: true,
      requiresCustomOptions: true,
      example: {
        name: "Choix de Transport",
        description: "Comment êtes-vous venu à l'hôtel ?",
        question: "Quel moyen de transport avez-vous utilisé ?",
      },
    },
    [ACTION_TYPES.REVIEW]: {
      name: "REVIEW",
      displayName: "Review",
      description: "Actions avec système de notation (1-5 étoiles)",
      periodicity: "Une seule fois par séjour",
      restriction: "L'utilisateur donne une note de 1 à 5",
      requiresPositiveResponse: false,
      requiresQuestion: true,
      requiresCustomOptions: false,
      example: {
        name: "Évaluation de l'Expérience",
        description: "Donnez votre avis sur votre expérience écologique",
        question: "Comment évaluez-vous votre expérience écologique durant ce séjour ?",
      },
    },
    [ACTION_TYPES.LIMEAT]: {
      name: "LIMEAT",
      displayName: "LimEat",
      description: "Actions liées à la limitation de la consommation de viande",
      periodicity: "Quotidienne",
      restriction: "Aucune",
      requiresPositiveResponse: false,
      requiresQuestion: false,
      requiresCustomOptions: false,
      example: {
        name: "Défi Réduction de Viande",
        description: "Réduisez votre impact carbone en limitant la viande",
      },
    },
    [ACTION_TYPES.CLAIM]: {
      name: "CLAIM",
      displayName: "Claim",
      description: "Actions de réclamation simple",
      periodicity: "Variable",
      restriction: "L'utilisateur clique simplement pour 'réclamer' des points",
      requiresPositiveResponse: false,
      requiresQuestion: false,
      requiresCustomOptions: false,
      example: {
        name: "Bonus Éco",
        description: "Récupérez votre bonus pour votre engagement écologique",
      },
    },
    [ACTION_TYPES.PROOF]: {
      name: "PROOF",
      displayName: "Proof (QR Code)",
      description: "Actions nécessitant de scanner un QR code pour validation",
      periodicity: "Une seule fois par séjour",
      restriction: "Nécessite la configuration d'un QR code via le service Shlink",
      requiresPositiveResponse: false,
      requiresQuestion: false,
      requiresCustomOptions: false,
      example: {
        name: "Défi QR Code",
        description: "Scannez le QR code pour valider votre action écologique",
      },
    },
    [ACTION_TYPES.YESNOMAIL]: {
      name: "YESNOMAIL",
      displayName: "Yes/No Mail",
      description: "Questions Oui/Non quotidiennes avec notification email à l'hôtelier",
      periodicity: "Quotidienne (par nuit)",
      restriction: "Les réponses positives sont envoyées par email à l'hôtelier",
      requiresPositiveResponse: true,
      requiresQuestion: true,
      requiresCustomOptions: false,
      example: {
        name: "Question Éco avec Notification",
        description: "Votre réponse sera transmise à l'hôtel pour améliorer les services",
        question: "Souhaitez-vous bénéficier du service de nettoyage supplémentaire ?",
      },
    },
    [ACTION_TYPES.QUIZ]: {
      name: "QUIZ",
      displayName: "Quiz",
      description: "Questions à choix multiples avec une seule bonne réponse",
      periodicity: "Une seule fois par séjour",
      restriction: "Nécessite la configuration des questions, réponses et explications",
      requiresPositiveResponse: false,
      requiresQuestion: false,
      requiresQuizData: true,
      example: {
        name: "Quiz Écologique",
        description: "Testez vos connaissances sur l'environnement",
        question: "Quelle est la principale source d'énergie renouvelable en France ?",
      },
    },
    [ACTION_TYPES.SKIP_SERVICE]: {
      name: "SKIP_SERVICE",
      displayName: "Skip Service",
      description: "Refus de service à fréquence (ménage, draps…) : le guest choisit une récurrence 1 jour sur 2/3/4 pour tout le séjour",
      periodicity: "Un seul choix par séjour, appliqué aux nuits restantes",
      restriction: "Masquée pour les séjours d'1 nuit ; séjour de 2 nuits = un seul skip (oui/non)",
      requiresPositiveResponse: false,
      requiresQuestion: false,
      requiresCustomOptions: false,
      example: {
        name: "Fréquence de ménage",
        description: "Choisissez la fréquence à laquelle vous déclinez le ménage",
      },
    },
    [ACTION_TYPES.LINK]: {
      name: "LINK",
      displayName: "Link",
      description: "Actions avec un lien externe vers une ressource ou une page",
      periodicity: "Variable",
      restriction: "Nécessite la configuration d'une URL de lien",
      requiresPositiveResponse: false,
      requiresQuestion: false,
      requiresCustomOptions: false,
      example: {
        name: "Découvrir nos Initiatives",
        description: "En savoir plus sur nos actions écologiques",
      },
    },
  };

  return typeInfoMap[type] || null;
};

/**
 * Obtient les champs requis pour un type d'action
 */
export const getRequiredFields = (type) => {
  const typeInfo = getActionTypeInfo(type);
  if (!typeInfo) return [];

  const baseFields = ["name", "nameB", "subtitle", "description"];
  const additionalFields = [];

  if (typeInfo.requiresPositiveResponse) {
    additionalFields.push("positiveResponse");
  }

  if (typeInfo.requiresQuestion) {
    additionalFields.push("question");
  }

  if (typeInfo.requiresCustomOptions) {
    additionalFields.push("customOptions");
  }

  return [...baseFields, ...additionalFields];
};

/**
 * Valide les données d'un formulaire d'action
 */
export const validateActionData = (type, data) => {
  const errors = [];
  const typeInfo = getActionTypeInfo(type);

  if (!typeInfo) {
    errors.push("Type d'action invalide");
    return {
      isValid: false,
      errors,
    };
  }

  // Validation des champs de base
  // actName peut être généré automatiquement à partir du titre en français
  const frenchDesc = data.descriptions?.find((d) => d.language === "fr");
  if (!data.actName?.trim() && !frenchDesc?.name?.trim()) {
    errors.push("Le titre en français est obligatoire (il sera utilisé comme nom technique)");
  }

  if (data.actReward === "" || data.actReward === null || data.actReward === undefined) {
    errors.push("La récompense est obligatoire");
  } else if (Number(data.actReward) < 0) {
    errors.push("La récompense doit être supérieure ou égale à 0");
  }

  // Validation des descriptions
  if (data.descriptions && data.descriptions.length > 0) {
    data.descriptions.forEach((desc, index) => {
      if (!desc.name?.trim()) {
        errors.push(`Le nom affiché est obligatoire pour la description ${index + 1}`);
      }
      if (!desc.nameB?.trim()) {
        errors.push(`Le titre alternatif est obligatoire pour la description ${index + 1}`);
      }
      if (!desc.subtitle?.trim()) {
        errors.push(`Le sous-titre est obligatoire pour la description ${index + 1}`);
      }
      if (!desc.description?.trim()) {
        errors.push(`La description est obligatoire pour la description ${index + 1}`);
      }
      if (typeInfo.requiresQuestion && !desc.question?.trim() && type !== "QUIZ") {
        errors.push(`La question est obligatoire pour le type ${type} dans la description ${index + 1}`);
      }
    });
  }

  // Validation spécifique selon le type
  if (typeInfo.requiresPositiveResponse && !data.actPositiveResponse) {
    errors.push("La réponse positive est obligatoire pour ce type d'action");
  }

  if (typeInfo.requiresCustomOptions) {
    if (!data.customOptions || data.customOptions.length < 2) {
      errors.push("Au moins 2 options sont obligatoires pour les actions CUSTOM");
    } else {
      data.customOptions.forEach((option, optionIndex) => {
        if (!option.descriptions || option.descriptions.length === 0) {
          errors.push(`Au moins une description est obligatoire pour l'option ${optionIndex + 1}`);
        } else {
          option.descriptions.forEach((optionDesc, descIndex) => {
            if (!optionDesc.label?.trim()) {
              errors.push(`Le libellé est obligatoire pour l'option ${optionIndex + 1}, description ${descIndex + 1}`);
            }
          });
        }
      });
    }
  }

  // Validation spécifique pour le type QUIZ
  if (type === ACTION_TYPES.QUIZ) {
    if (!data.quizData) {
      errors.push("Les données du quiz sont obligatoires");
    } else {
      // Validation de la difficulté
      if (!["EASY", "MEDIUM", "HARD"].includes(data.quizData.difficulty)) {
        errors.push("Le niveau de difficulté doit être EASY, MEDIUM ou HARD");
      }

      // Validation des réponses
      if (!data.quizData.answers || data.quizData.answers.length < 2) {
        errors.push("Le quiz doit avoir au moins 2 réponses");
      } else {
        let correctAnswers = 0;
        data.quizData.answers.forEach((answer, index) => {
          if (!answer.descriptions || answer.descriptions.length === 0) {
            errors.push(`La réponse ${index + 1} doit avoir au moins une description`);
          } else {
            answer.descriptions.forEach((desc, descIndex) => {
              if (!desc.text?.trim()) {
                errors.push(`Le texte est obligatoire pour la réponse ${index + 1}, description ${descIndex + 1}`);
              }
            });
          }
          if (answer.isCorrect === 1) correctAnswers++;
        });

        if (correctAnswers < 1) {
          errors.push("Le quiz doit avoir au moins une bonne réponse");
        }
      }
    }
  }

  // Validation spécifique pour le type LINK
  if (type === ACTION_TYPES.LINK) {
    if (!data.actLinkUrl || !data.actLinkUrl.trim()) {
      errors.push("L'URL du lien est obligatoire pour les actions LINK");
    } else {
      // Validation du format URL
      try {
        new URL(data.actLinkUrl.trim());
      } catch (e) {
        errors.push("L'URL du lien doit être une URL valide (ex: https://www.example.com)");
      }
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

/**
 * Crée un objet de données par défaut pour un type d'action
 */
export const createDefaultActionData = (type) => {
  const typeInfo = getActionTypeInfo(type);
  if (!typeInfo) return {};

  const defaultData = {
    actName: "", // Sera généré automatiquement à partir du titre en français
    actType: type,
    actReward: 50,
    actPictureURL: "",
    actTitleColor: "#FFFFFF",
    actSavingsEuro: 0,
    actSavingsWater: 0,
    actSavingsCO2: 0,
    descriptions: [
      {
        language: "fr",
        name: "",
        nameB: "",
        subtitle: "",
        description: "",
        // N'ajouter le champ question que si le type l'exige ET que ce n'est pas un quiz
        ...(typeInfo.requiresQuestion && typeInfo.name !== "QUIZ" && { question: "" }),
        // Ajouter les champs spécifiques LINK si c'est une action LINK
        ...(type === ACTION_TYPES.LINK && {
          question: "",
          linkButtonText: "",
        }),
      },
    ],
  };

  // Ajouter actLinkUrl pour les actions LINK
  if (type === ACTION_TYPES.LINK) {
    defaultData.actLinkUrl = "";
  }

  if (typeInfo.requiresPositiveResponse) {
    defaultData.actPositiveResponse = "YES";
  }

  if (typeInfo.requiresCustomOptions) {
    defaultData.customOptions = [
      {
        pictureURL: "",
        descriptions: [
          {
            language: "fr",
            label: "",
          },
        ],
      },
      {
        pictureURL: "",
        descriptions: [
          {
            language: "fr",
            label: "",
          },
        ],
      },
    ];
  }

  if (typeInfo.requiresQuizData) {
    defaultData.descriptions = [
      {
        language: "fr",
        name: "",
        nameB: "",
        subtitle: "",
        description: "",
      },
      {
        language: "en",
        name: "",
        nameB: "",
        subtitle: "",
        description: "",
      },
    ];

    defaultData.quizData = {
      difficulty: "EASY",
      descriptions: [
        {
          language: "fr",
          question: "",
          explanation: "",
        },
        {
          language: "en",
          question: "",
          explanation: "",
        },
      ],
      answers: [
        {
          position: 1,
          isCorrect: 1,
          descriptions: [
            {
              language: "fr",
              text: "",
            },
            {
              language: "en",
              text: "",
            },
          ],
        },
        {
          position: 2,
          isCorrect: 0,
          descriptions: [
            {
              language: "fr",
              text: "",
            },
            {
              language: "en",
              text: "",
            },
          ],
        },
        {
          position: 3,
          isCorrect: 0,
          descriptions: [
            {
              language: "fr",
              text: "",
            },
            {
              language: "en",
              text: "",
            },
          ],
        },
      ],
    };
  }

  return defaultData;
};
